import type { LpSmbHomeContent } from "./lp-express-smb-home";

export const TEMPLATE_STUDIO_RENDERERS = ["product-hero", "smb-home"] as const;
export type TemplateStudioRenderer = typeof TEMPLATE_STUDIO_RENDERERS[number];

export function templateStudioRenderer(value: unknown): TemplateStudioRenderer {
  if (value === undefined) return "product-hero";
  if (value === "product-hero" || value === "smb-home") return value;
  throw new Error("Unsupported Template Studio renderer");
}

const texts = (label: string, count: number) =>
  Array.from({ length: count }, (_, i) => `[${label} ${i + 1}]`);
const rows = (label: string, count: number) =>
  texts(label, count).map(title => ({ title, body: `${title.slice(0, -1)} BODY]` }));

/** Structure only. Never use this seed as missing customer facts. */
export const TEMPLATE_STUDIO_SMB_SEED: LpSmbHomeContent = {
  eyebrow: "[EYEBROW]", headline: "[PRIMARY HEADLINE]", subhead: "[SUBHEAD]",
  primaryCtaText: "[CTA LABEL]", primaryCtaSub: "[CTA SUBLINE]",
  trustBar: { label: "[TRUST LABEL]", items: texts("TRUST ITEM", 6) },
  services: { heading: "[SERVICES HEADING]", dek: "[SERVICES DEK]",
    items: rows("SERVICE", 8).map(row => ({ icon: "[SERVICE ICON]", ...row })) },
  about: { heading: "[ABOUT HEADING]", body: "[ABOUT BODY]", highlights: texts("HIGHLIGHT", 4) },
  whyUs: { heading: "[WHY US HEADING]", items: rows("REASON", 6) },
  proof: { heading: "[PROOF HEADING]", items: texts("TESTIMONIAL", 6).map(quote => ({ quote, attribution: "[ATTRIBUTION]" })) },
  process: { heading: "[PROCESS HEADING]", items: rows("STEP", 5) },
  serviceAreas: { heading: "[AREAS HEADING]", dek: "[AREAS DEK]", areas: texts("SERVICE AREA", 20) },
  faq: { heading: "[FAQ HEADING]", items: texts("QUESTION", 8).map(q => ({ q, a: "[ANSWER]" })) },
  contact: { heading: "[CONTACT HEADING]", dek: "[CONTACT DEK]", ctaText: "[CONTACT CTA]",
    phone: "", email: "", address: "", hours: "" },
  footer: { tagline: "[FOOTER TAGLINE]", disclaimer: "" },
  nav: { items: (["services", "about", "why-us", "areas", "faq", "contact"] as const)
    .map(anchor => ({ label: `[${anchor.toUpperCase()} LABEL]`, anchor })) },
};

export function studioStringLeaves(value: unknown, prefix = ""): string[] {
  if (typeof value === "string") return [prefix];
  if (!value || typeof value !== "object") return [];
  return Object.entries(value).flatMap(([key, child]) =>
    studioStringLeaves(child, prefix ? `${prefix}.${key}` : key));
}

export const TEMPLATE_STUDIO_SMB_BINDINGS = studioStringLeaves(TEMPLATE_STUDIO_SMB_SEED);
